import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, createClass as _createClass, defineProperty as _defineProperty, taggedTemplateLiteral as _taggedTemplateLiteral, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../../node_modules/prop-types/index.js';
import React from 'react';
import classnames from '../../../node_modules/classnames/index.js';
import { styled, useThemeProps } from '@mui/material';
import Field from '../Field.js';
import withFormArray$1 from '../../../cinnamon-core/es/components/forms/withFormArray.js';
import Table from '../../tables/Table.js';
import { createComponentSlot } from '../../../modules/styling/theme.js';
import { omitProps, fieldErrors, prettifyField } from '../../../cinnamon-core/es/components/forms/utils.js';

var _templateObject;
var componentRoot = createComponentSlot({
  name: "CinFormArrayTable",
  slot: "Root"
});

var ArrayTableBase = /*#__PURE__*/function (_React$Component) {
  _inherits(ArrayTableBase, _React$Component);

  var _super = _createSuper(ArrayTableBase);

  function ArrayTableBase() {
    _classCallCheck(this, ArrayTableBase);

    return _super.apply(this, arguments);
  }

  _createClass(ArrayTableBase, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          labelProps = _this$props.labelProps,
          minLength = _this$props.minLength,
          showErrors = _this$props.showErrors,
          allErrors = _this$props.allErrors,
          animateErrors = _this$props.animateErrors,
          disabled = _this$props.disabled,
          value = _this$props.value,
          arrayKey = _this$props.arrayKey,
          errors = _this$props.errors,
          className = _this$props.className,
          passThruChildren = _this$props.passThruChildren,
          passThruProps = _this$props.passThruProps,
          renderItem = _this$props.renderItem,
          renderExpandedRow = _this$props.renderExpandedRow,
          virtualized = _this$props.virtualized,
          virtualizationOptions = _this$props.virtualizationOptions;
      var tableProps = omitProps(passThruProps, Object.keys(ArrayTableBase.propTypes));
      return /*#__PURE__*/React.createElement(Field, {
        required: !!minLength,
        disabled: disabled,
        label: label,
        labelProps: labelProps,
        width: null,
        errors: fieldErrors(errors, showErrors, allErrors),
        animateErrors: animateErrors,
        className: classnames(componentRoot.className, className)
      }, /*#__PURE__*/React.createElement(Table, _extends({}, tableProps, {
        data: value,
        dataKey: arrayKey,
        renderRowContent: function renderRowContent(index) {
          return typeof passThruChildren === "function" ? function (item, state, events) {
            return renderItem(value[index], index, passThruChildren(item, state, events), [state.expanded]);
          } : renderItem(value[index], index, passThruChildren);
        },
        renderExpandedRow: renderExpandedRow ? function (item, state, events) {
          return renderItem(value[state.itemIndex], state.itemIndex, renderExpandedRow(item, state, events));
        } : undefined,
        virtualized: virtualized,
        virtualizationOptions: virtualizationOptions
      }), passThruChildren));
    }
  }]);

  return ArrayTableBase;
}(React.Component);

_defineProperty(ArrayTableBase, "propTypes", {
  virtualized: propTypes.bool,
  propagateUpdates: propTypes.any,
  autoRemove: propTypes.bool,
  autoAddPopulate: propTypes.func,
  autoAdd: propTypes.bool,
  readOnly: propTypes.bool,
  disabled: propTypes.bool,
  animateErrors: propTypes.oneOfType([propTypes.number, propTypes.bool]),
  allErrors: propTypes.bool,
  showErrors: propTypes.bool,
  arrayKey: propTypes.string,
  field: propTypes.string.isRequired,
  maxLengthError: propTypes.string,
  maxLength: propTypes.number,
  minLengthError: propTypes.string,
  minLength: propTypes.number,
  variant: propTypes.any,
  sx: propTypes.any,
  className: propTypes.string,
  virtualizationOptions: propTypes.any,
  labelProps: propTypes.any,
  label: propTypes.node
});

_defineProperty(ArrayTableBase, "defaultProps", {
  arrayKey: "key",
  autoAdd: false,
  autoAddPopulate: function autoAddPopulate(arrayKey) {
    return _defineProperty({}, arrayKey, Date.now());
  },
  autoRemove: false
});

var ConnectedArrayTable = withFormArray$1({
  defaultProps: {
    arrayKey: "key",
    autoAdd: false,
    autoAddPopulate: function autoAddPopulate(arrayKey) {
      return _defineProperty({}, arrayKey, Date.now());
    },
    autoRemove: false
  },
  displayName: function displayName(props) {
    return props.label && typeof props.label === "string" ? props.label : prettifyField(props.field);
  }
})(ArrayTableBase);
var ArrayTableRoot = styled(ConnectedArrayTable, componentRoot.styledOptions)(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
/**
 * Combines a Form.Array and Table component, to enable form array data to be rendered as table rows
 */

var ArrayTable = function ArrayTable(props) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });
  return /*#__PURE__*/React.createElement(ArrayTableRoot, rootProps);
};

var ArrayTable$1 = ArrayTable;

export { ArrayTable$1 as default };
